// @flow
import React, { Component } from 'react';

import ValidateText from './ValidateText.jsx';

/*
  Text that will consider non-numeric text invalid.
  Accepts negative and decimals.
*/

type Props = {
  field: string,
  initialValue?: ?string,
}

class NumericText extends Component<Props> {
  render() {
    const { field, initialValue, ...rest } = this.props;
    return <ValidateText
      field={this.props.field}
      initialValue={this.props.initialValue}
      regex={/^-?\d*(\.\d+)?$/}
      errorText={'Please enter a valid numeric value'}
      {...rest}
    />;
  }
}

export default NumericText;



// WEBPACK FOOTER //
// ./client/src/components/NumericText.jsx